// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  addonsHeading: {
    marginBottom: '16px',
    marginTop: '16px',
    textTransform: 'capitalize',
  },
  unavailableDeliverables: {
    pointerEvents: 'none',

    '& h3': {
      color: 'lightgray',
    },
    '& h4': {
      color: 'lightgray',
    },
    '& p': {
      color: 'lightgray',
    },
    '& span': {
      color: 'lightgray',
    },
  },
  noDeliverableMessage: {
    marginBottom: '8px',
    marginTop: '8px',
    fontSize: 'small',
    fontWeight: 400,
    color: 'lightgray',
  },
  checked: {
    color: '#01A1DD !important',
  },
  description: {
    marginBottom: '15px',
  },
  listItem: {
    padding: '0px',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridColumnGap: theme.spacing(1),
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  itemName: {
    fontWeight: 400,
    fontSize: '13px',
  },
  costPerAcre: {
    fontSize: '13px',
  },
  right: {
    fontWeight: 400,
    fontSize: '13px',
    position: 'absolute',
    right: 0,
  },
  headContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  attributeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  toggleButton: {
    fontSize: '0.65rem',
    padding: '4px 8px',
    '&.Mui-selected': {
      backgroundColor: '#01A1DD',
      color: 'white',
      '&:hover': {
        backgroundColor: '#01A1DD',
        color: 'white',
      },
    },
    '&:hover': {
      backgroundColor: 'inherit',
      color: 'inherit',
    },
  },
  warningText: {
    width: '600px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'block',
  },
  lowConfidenceContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 2,
  },
  attributeAddOnIcon: {
    color: '#01A1DD',
  },
  hiddenTooltip: {
    display: 'none',
  },
});

export default styles;
